exports.data = {
    path: '/',
    name: 'dashboard', 
    meta: {
      authRequired: true,
    },
    component: () => import("@/views/main/Dashboard.vue")
}